import { GetFolders, GetFoldersVariables } from '@chegg-wt/core/queries/GetFolders'
import {
  GET_FOLDERS,
  CREATE_FOLDER,
  EDIT_FOLDER,
  DELETE_FOLDER,
} from '@chegg-wt/core/queries/Folder'
import {
  FETCH_PROJECT,
  FETCH_PROJECTS,
  SEARCH_PROJECTS,
  MOVE_PROJECTS_TO_FOLDER,
  UPDATE_PROJECT,
  FOLDERS_CREATE_PROJECT,
  DELETE_PROJECTS,
  STAR_PROJECT,
  GET_PROJECTS_BY_FOLDER,
  VISIT_PROJECT,
} from '@chegg-wt/core/queries/Project'
import {
  GET_CITATION,
  UPDATE_CITATION,
  MOVE_CITATIONS,
  DELETE_CITATION,
  CREATE_CITATION,
} from '@chegg-wt/core/queries/Citations'
import { GetCitation, GetCitationVariables } from '@chegg-wt/core/queries/GetCitation'
import {
  UpdateProjectVariables,
  UpdateProject,
} from '@chegg-wt/core/queries/UpdateProject'
import { MoveProjectsVariables } from '@chegg-wt/core/queries/MoveProjects'
import {
  FoldersCreateProjectVariables,
  FoldersCreateProject,
} from '@chegg-wt/core/queries/FoldersCreateProject'
import {
  DeleteProjectsVariables,
  DeleteProjects,
} from '@chegg-wt/core/queries/DeleteProjects'
import { StarProjectVariables, StarProject } from '@chegg-wt/core/queries/StarProject'
import { CreateFolderVariables, CreateFolder } from '@chegg-wt/core/queries/CreateFolder'
import { EditFolder, EditFolderVariables } from '@chegg-wt/core/queries/EditFolder'
import { DeleteFolder, DeleteFolderVariables } from '@chegg-wt/core/queries/DeleteFolder'
import {
  SearchProjectsVariables,
  SearchProjects,
} from '@chegg-wt/core/queries/SearchProjects'
import { TRANSFER_OWNERSHIP } from '@chegg-wt/core/queries/User'
import { TransferOwnership } from '@chegg-wt/core/queries/TransferOwnership'
import { flattenData } from '@chegg-wt/core/utils/citations'
import {
  DeleteCitationVariables,
  DeleteCitation,
} from '@chegg-wt/core/queries/DeleteCitation'
import { FetchProject, FetchProjectVariables } from '@chegg-wt/core/queries/FetchProject'
import {
  FetchProjectsVariables,
  FetchProjects,
} from '@chegg-wt/core/queries/FetchProjects'
import {
  UpdateCitation,
  UpdateCitationVariables,
} from '@chegg-wt/core/queries/UpdateCitation'
import {
  GetFormattedCitationsVariables,
  GetFormattedCitations,
} from '@chegg-wt/core/queries/GetFormattedCitations'
import { GET_FORMATTED_CITATIONS } from '@chegg-wt/core/queries/FormattedCitations'
import {
  GetProjectsByFolderVariables,
  GetProjectsByFolder,
} from '@chegg-wt/core/queries/GetProjectsByFolder'
import {
  MoveCitations,
  MoveCitationsVariables,
} from '@chegg-wt/core/queries/MoveCitations'
import { CreateCitation, CreateCitationVariables } from '../queries/CreateCitation'
import { SearchJstor, SearchJstorVariables } from '../queries/SearchJstor'
import { SearchWebsite, SearchWebsiteVariables } from '../queries/SearchWebsite'
import { SearchJournal, SearchJournalVariables } from '../queries/SearchJournal'
import { SearchWorldcat, SearchWorldcatVariables } from '../queries/SearchWorldcat'
import { Capitalization, CapitalizationVariables } from '../queries/Capitalization'
import {
  SEARCH_JSTOR,
  SEARCH_JOURNAL,
  SEARCH_WEBSITE,
  SEARCH_WORLDCAT,
  SEARCH_WEBSITE_BRAVE,
} from '../queries/SearchCitationSource'
import { CAPITALIZE } from '../queries/CapitalizeCitation'
import { VisitProject, VisitProjectVariables } from '../queries/VisitProject'
import { GetPapers, GetPapersVariables } from '../queries/GetPapers'
import { GET_PAPERS } from '../queries/Papers'
import { client } from './graphApi'

export const bff = {
  createCitation: (variables: CreateCitationVariables) =>
    client
      .mutate<CreateCitation>({
        mutation: CREATE_CITATION,
        variables,
      })
      .then(({ data }) => flattenData(data.createCitation)),
  getCitation: (variables: GetCitationVariables) =>
    client
      .query<GetCitation>({
        query: GET_CITATION,
        variables,
      })
      .then(({ data }) => flattenData(data.citation)),
  getCitations: (variables: GetFormattedCitationsVariables) =>
    client
      .query<GetFormattedCitations>({
        query: GET_FORMATTED_CITATIONS,
        variables,
      })
      .then(({ data }) => data.formattedCitations),
  updateCitation: (variables: UpdateCitationVariables) =>
    client
      .mutate<UpdateCitation>({
        mutation: UPDATE_CITATION,
        variables,
      })
      .then(({ data }) => flattenData(data.updateCitation)),
  moveCitations: (variables: MoveCitationsVariables) =>
    client
      .mutate<MoveCitations>({
        mutation: MOVE_CITATIONS,
        variables,
      })
      .then(({ data }) => data.moveCitations),
  deleteCitation: (variables: DeleteCitationVariables) =>
    client.mutate<DeleteCitation>({
      mutation: DELETE_CITATION,
      variables,
    }),
  getProject: (variables: FetchProjectVariables) =>
    client
      .query<FetchProject>({
        query: FETCH_PROJECT,
        variables,
      })
      .then(({ data }) => data.project),
  getProjects: (variables: FetchProjectsVariables = {}) =>
    client
      .query<FetchProjects>({
        query: FETCH_PROJECTS,
        variables,
      })
      .then(({ data }) => data.projects),
  getProjectsByFolder: (variables: GetProjectsByFolderVariables) =>
    client
      .query<GetProjectsByFolder>({
        query: GET_PROJECTS_BY_FOLDER,
        variables,
      })
      .then(({ data }) => data.projects),
  searchProjects: (variables: SearchProjectsVariables = {}) =>
    client
      .query<SearchProjects>({
        query: SEARCH_PROJECTS,
        variables,
      })
      .then(({ data }) => data.projects),
  moveProjectsToFolder: (variables: MoveProjectsVariables) =>
    client.mutate({
      mutation: MOVE_PROJECTS_TO_FOLDER,
      variables,
    }),
  createProject: (variables: FoldersCreateProjectVariables) =>
    client
      .mutate<FoldersCreateProject>({
        mutation: FOLDERS_CREATE_PROJECT,
        variables,
      })
      .then(({ data }) => data.createProject),
  editProject: (variables: UpdateProjectVariables) =>
    client
      .mutate<UpdateProject>({
        mutation: UPDATE_PROJECT,
        variables,
      })
      .then(({ data }) => data.updateProject),
  visitProject: (variables: VisitProjectVariables) =>
    client
      .mutate<VisitProject>({
        mutation: VISIT_PROJECT,
        variables,
      })
      .then(({ data }) => data.visitProject),
  deleteProjects: (variables: DeleteProjectsVariables) =>
    client.mutate<DeleteProjects>({
      mutation: DELETE_PROJECTS,
      variables,
    }),
  starProject: (variables: StarProjectVariables) =>
    client.mutate<StarProject>({
      mutation: STAR_PROJECT,
      variables,
    }),
  getFolders: (variables: GetFoldersVariables = {}) =>
    client
      .query<GetFolders>({ query: GET_FOLDERS, variables })
      .then(({ data }) => data.folders),
  createFolder: (variables: CreateFolderVariables) =>
    client.mutate<CreateFolder>({
      mutation: CREATE_FOLDER,
      variables,
      refetchQueries: [{ query: GET_FOLDERS }],
      awaitRefetchQueries: true,
    }),
  editFolder: (variables: EditFolderVariables) =>
    client.mutate<EditFolder>({
      mutation: EDIT_FOLDER,
      variables,
      refetchQueries: [{ query: GET_FOLDERS }],
      awaitRefetchQueries: true,
    }),
  deleteFolder: (variables: DeleteFolderVariables) =>
    client.mutate<DeleteFolder>({
      mutation: DELETE_FOLDER,
      variables,
      refetchQueries: [{ query: GET_FOLDERS }],
      awaitRefetchQueries: true,
    }),
  transferOwnership: () =>
    client.mutate<TransferOwnership>({
      mutation: TRANSFER_OWNERSHIP,
    }),
  capitalizeCitations: (variables: CapitalizationVariables) =>
    client
      .query<Capitalization>({
        query: CAPITALIZE,
        variables,
      })
      .then(({ data }) => data.capitalization.citations),
  searchJstor: (variables: SearchJstorVariables) =>
    client
      .query<SearchJstor>({
        query: SEARCH_JSTOR,
        variables,
        fetchPolicy: 'cache-first',
      })
      .then(({ data }) => data.searchCitationSource.results),
  searchWebsite: (variables: SearchWebsiteVariables) =>
    client
      .query<SearchWebsite>({
        query: SEARCH_WEBSITE,
        variables,
      })
      .then(({ data }) => data.searchCitationSource.results),
  searchWebsiteBrave: (variables: SearchWebsiteVariables) =>
    client
      .query<SearchWebsite>({
        query: SEARCH_WEBSITE_BRAVE,
        variables,
      })
      .then(({ data }) => data.searchCitationSource.results),
  searchJournal: (variables: SearchJournalVariables) =>
    client
      .query<SearchJournal>({
        query: SEARCH_JOURNAL,
        variables,
        fetchPolicy: 'cache-first',
      })
      .then(({ data }) => data.searchCitationSource.results),
  searchWorldcat: (variables: SearchWorldcatVariables) =>
    client
      .query<SearchWorldcat>({
        query: SEARCH_WORLDCAT,
        variables,
      })
      .then(({ data }) => data.searchCitationSource.results),
  getPapers: (variables: GetPapersVariables) =>
    client
      .query<GetPapers>({ query: GET_PAPERS, variables })
      .then(({ data }) => data.getPapers),
}
